/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 09/05/2025 | Lic. José Luis Aragón Cervantes  | Creación
* --------------------------------------------------------------------------------------- */

import TextField from "../ui/TextField";
import React, { Fragment, useState, useEffect } from "react";
import { NumericFormat } from 'react-number-format';
import { AttachMoney, CreditCard, AccountBalance, CallToAction, AccountBalanceWallet, Scale } from '@mui/icons-material'; // Importa los íconos que necesites

import { Modal, Box, Tooltip, IconButton } from "@mui/material";
import { NumberFormat$ } from "../../settings/utils";
import { useVentas } from '../../context/Ventas/VentasContext'

import SizeSoftXTableVentas from "../leyout/SizeSoftXTableVentas";
import { height } from "@mui/system";

// Estilos para el modal con efecto suavizado de desplazamiento
const modalStyle = {
    Scale:'90%',
    position: 'fixed',
    top: '3%',
    right: '12%',
    width: '72vw',
    height:'690px',
    maxWidth: '82vw',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    transform: 'translateX(300%)',
    transition: 'transform 0.5s ease-in-out',
    overflowY: 'auto',
    overflowX: 'auto'
};

export default function ModalVisorCortes(props) {
    const { openModalVisorCortes, handleCloseModalVisorCortes, listaData , handleGenerarCorte } = props;

    const [internalOpen, setInternalOpen] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    
    // Efecto para manejar la apertura/cierre con retardo para permitir la animación
    useEffect(() => {
        if (openModalVisorCortes) {
            setInternalOpen(true);
            setTimeout(() => {
                setModalVisible(true);
            }, 50);
        } else {
            setModalVisible(false);
            setTimeout(() => {
                setInternalOpen(false);
            }, 500);
        }
    }, [openModalVisorCortes]);

    const modalVisibleStyle = {
        transform: modalVisible ? 'translateX(0)' : 'translateX(300%)',
    };

    const [totalEfectivo, setTotalEfectivo] = useState(0);
    const [totalCambio, setTotalCambio] = useState(0);
    const [totalDevoluciones, setTotalDevoluciones] = useState(0);
    const [totalTarjetaDebito, setTotalTarjetaDebito] = useState(0);
    const [totalTarjetaCredito, setTotalTarjetaCredito] = useState(0);
    const [totalTransferencia, setTotalTransferencia] = useState(0);
    const [totalApartados, setTotalApartados] = useState(0);
    const [totalCreditoCliente, setTotalCreditoCliente] = useState(0);
    const [totalGeneral, setTotalGeneral] = useState(0);

    const [listChanged, setListChanged] = useState([]);
    const handleOnchangeStatus=(e)=>{
        setListChanged(...listChanged, e);
    };

    const handleGenerarCorteDetalles=()=>{
        handleGenerarCorte(listChanged);
    };
    
    const handleRecalcularData=async()=>{
        await setTotalEfectivo(listChanged.filter(e => e.status === true).reduce((sum, r) => sum + (r.totalefectivo || 0), 0).toFixed(2));
        await setTotalCambio(listChanged.filter(e => e.status === true).reduce((sum, r) => sum + (r.totalcambio || 0), 0).toFixed(2));
        await setTotalDevoluciones(listChanged.filter(e => e.status === true).reduce((sum, r) => sum + (r.totaldevolucion || 0), 0).toFixed(2));
        await setTotalTarjetaDebito(listChanged.filter(e => e.status === true).reduce((sum, r) => sum + (r.totaltarjetadebito || 0), 0).toFixed(2));
        await setTotalTarjetaCredito(listChanged.filter(e => e.status === true).reduce((sum, r) => sum + (r.totaltarjetacredito || 0), 0).toFixed(2));
        await setTotalTransferencia(listChanged.filter(e => e.status === true).reduce((sum, r) => sum + (r.totaltransferencia || 0), 0).toFixed(2));
        await setTotalCreditoCliente(listChanged.filter(e => e.status === true).reduce((sum, r) => sum + (r.totalcreditocliente || 0), 0).toFixed(2));
        await setTotalApartados(listChanged.filter(e => e.status === true).reduce((sum, r) => sum + (r.totalabonosapartados || 0), 0).toFixed(2));
        await setTotalGeneral(listChanged.filter(e => e.status === true).reduce((sum, r) => sum + (r.totalventa || 0), 0).toFixed(2));
    };

    useEffect(() => {
        if(listaData.cabecero !== undefined)
        {
            const lstData = listaData.cabecero.map((element, index) => ({
                ...element,
                status: false,
                id: index + 1,
                totalventa: (element.totalefectivo - element.totalcambio) - element.totaldevoluciones + element.totaltarjetacredito + element.totaltarjetadebito + element.totalcreditocliente + element.totalabonosapartados,
            }));
            setListChanged(lstData);
        }
    }, [listaData]);

    const handleChangeStatus =async(event, row) => {
        const updatedList = await listChanged.map((item) =>
            item.id === row.id ? { ...item, status: event.target.checked ? true:false } : item
        );
        await setListChanged(updatedList);
    };

    const [rowSelect, setRwSelect] = useState({});
    const handleChangeCorteSeleccionado=(e)=>{
        setRwSelect(e);
    };
    
    useEffect(()=>{
        handleRecalcularData();
    },[listChanged])

    return (
        <Modal
            open={internalOpen}
            onClose={handleCloseModalVisorCortes}
            aria-labelledby="menu-modal-title"
            aria-describedby="menu-modal-description"
            closeAfterTransition
        >
            <Box sx={{ ...modalStyle, ...modalVisibleStyle }}>
                <Fragment>
                    <div className="detalles-totales-header">
                        <h1>Generación de cortes</h1>
                    </div>
                    <div className="detalles-totales-body">
                        {/* Lista tipo tabla, campos: status = checkbox , caja = textfield, vendedor = textfield, totalventa = textfield, fecha venta = textfield */}

                        <SizeSoftXTableVentas
                            columns={[
                                    { title: "Status", 
                                        hideSort: false,
                                        field: "status",
                                        render: (row) => (
                                            <div>
                                                <input
                                                    type="checkbox"
                                                    name="statuscheck"
                                                    checked={row.status}
                                                    onChange={(event) => handleChangeStatus(event, row)}
                                                />
                                            </div>
                                        )
                                    },
                                    { title: "Caja", field: "pc" },
                                    { title: "Vendedor", field: "vendedor" },
                                    { title: "Total venta", field: "totalventa" },
                                    { title: "Fecha corte", field: "fechacorte" },
                                ]}
                                id={"id"}
                                data={listChanged == null ? [] : listChanged}
                                onChange={(e) => handleOnchangeStatus(e)}
                                row={rowSelect}
                                setRow={handleChangeCorteSeleccionado}
                                fontSize="small"
                                rowsPerPageIntro={50}
                        />
                    </div>
                    <div className="detalles-totales-foot">
                        <div className="detalles-totales-efectivo">
                            <p>Total efectivo:</p>
                            <NumericFormat
                                value={totalEfectivo}
                                displayType="text"
                                thousandSeparator={true}
                                prefix="$&nbsp;"
                                decimalScale={2}
                                fixedDecimalScale
                                customInput={TextField}
                                label="Total efectivo"
                                disabled
                            />&nbsp;&nbsp;&nbsp;
                            <p>Total cambio:</p>
                            <NumericFormat
                                value={totalCambio}
                                displayType="text"
                                thousandSeparator={true}
                                prefix="$&nbsp;"
                                decimalScale={2}
                                fixedDecimalScale
                                customInput={TextField}
                                label="Total cambio"
                                disabled
                            />                            
                        </div>
                        <div className="detalles-totales-efectivo">
                            <p>Total devoluciones:&nbsp;&nbsp;&nbsp;</p>
                            <NumericFormat
                                value={totalDevoluciones}
                                displayType="text"
                                thousandSeparator={true}
                                prefix="$&nbsp;"
                                decimalScale={2}
                                fixedDecimalScale
                                customInput={TextField}
                                label="Total devoluciones"
                                sx={{ margin: '.5rem .3rem', width: '250px' }}
                                disabled
                            />                            
                        </div>
                        <div className="detalles-totales-efectivo">
                            <p>Total apartados:&nbsp;&nbsp;&nbsp;</p>
                            <NumericFormat
                                value={totalApartados}
                                displayType="text"
                                thousandSeparator={true}
                                prefix="$&nbsp;"
                                decimalScale={2}
                                fixedDecimalScale
                                customInput={TextField}
                                label="Total apartados"
                                sx={{ margin: '.5rem .3rem', width: '250px' }}
                                disabled
                            />                            
                        </div>
                        <div className="detalles-totales-efectivo">
                            <p>Total tarjeta crédito:&nbsp;&nbsp;&nbsp;</p>
                            <NumericFormat
                                value={totalTarjetaCredito}
                                displayType="text"
                                thousandSeparator={true}
                                prefix="$&nbsp;"
                                decimalScale={2}
                                fixedDecimalScale
                                customInput={TextField}
                                label="Total tarjeta crédito"
                                sx={{ margin: '.5rem .3rem', width: '250px' }}
                                disabled
                            />                            
                        </div>
                        <div className="detalles-totales-efectivo">
                            <p>Total tarjeta débito:&nbsp;&nbsp;&nbsp;</p>
                            <NumericFormat
                                value={totalTarjetaDebito}
                                displayType="text"
                                thousandSeparator={true}
                                prefix="$&nbsp;"
                                decimalScale={2}
                                fixedDecimalScale
                                customInput={TextField}
                                label="Total tarjeta débito"
                                sx={{ margin: '.5rem .3rem', width: '250px' }}
                                disabled
                            />                            
                        </div>
                        <div className="detalles-totales-efectivo">
                            <p>Total transferencia:&nbsp;&nbsp;&nbsp;</p>
                            <NumericFormat
                                value={totalTransferencia}
                                displayType="text"
                                thousandSeparator={true}
                                prefix="$&nbsp;"
                                decimalScale={2}
                                fixedDecimalScale
                                customInput={TextField}
                                label="Total transferencia"
                                sx={{ margin: '.5rem .3rem', width: '250px' }}
                                disabled
                            />                            
                        </div>
                        <div className="detalles-totales-efectivo">
                            <p>Total credoto clientes:&nbsp;&nbsp;&nbsp;</p>
                            <NumericFormat
                                value={totalCreditoCliente}
                                displayType="text"
                                thousandSeparator={true}
                                prefix="$&nbsp;"
                                decimalScale={2}
                                fixedDecimalScale
                                customInput={TextField}
                                label="Total crédito clientes"
                                sx={{ margin: '.5rem .3rem', width: '250px' }}
                                disabled
                            />                            
                        </div>
                    </div>
                    <div className="detalles-totales-efectivo">
                        <p>Total general:</p>
                        <NumericFormat
                            value={totalGeneral}
                            displayType="text"
                            thousandSeparator={true}
                            prefix="$&nbsp;"
                            decimalScale={2}
                            fixedDecimalScale
                            customInput={TextField}
                            label="Total general"
                            disabled
                        />                            
                    </div>
                    <div>
                        <button className="boton-generar" onClick={() => handleGenerarCorteDetalles()} style={{ backgroundColor: '#a9701e', color: '#FFFFFF' }}>Generar corte</button> 
                    </div>
                </Fragment>
            </Box>
        </Modal>
    );
}